export const testIds = {
  ddSetup: {
    banner: 'dd-setup-banner',
    button: 'dd-setup-now-button',
  },
};
